<div class="download-url">
  <a [href]="url" [download]="filename" (click)="handleClick($event);">
    <ng-content select=".app-download-content"></ng-content>
  </a>
</div>
